import { DefaultCustomItemOptions } from '@/components/documents/CustomItems/DefaultCustomItemOptions'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const TexasCustomItems = {
	...DefaultCustomItemOptions,
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [],
		[PbSubcategory.ServiceEmbalming]: [],
		[PbSubcategory.ServiceRefrigeration]: [
			{
				prop: 'numberOfDays',
				label: 'Number of Days',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceOtherBodyPreparation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceVisitationViewing]: [
			{
				prop: 'numberOfDays',
				label: 'Number of Days',
				type: 'number',
				required: false,
			},
			{
				prop: 'amountPerDay',
				label: 'Amount Per Day',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceFuneralMemorial]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceBodyPreparation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceCosmeticBeautician]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceDressingCasketing]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceRosaryOrPrayer]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceMemorialService]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceGravesideService]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceCremationService]: [],
		[PbSubcategory.ServiceForwardingRemains]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceReceivingRemains]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceOtherFacilities]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationHearse]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
			{
				prop: 'specificMileAllotment',
				label: 'Specific Mile Allotment',
				type: 'text',
				required: false,
			},
			{
				prop: 'amountPerMile',
				label: 'Amount Per Mile',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationFamilyCarLimo]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
			{
				prop: 'specificMileAllotment',
				label: 'Specific Mile Allotment',
				type: 'text',
				required: false,
			},
			{
				prop: 'amountPerMile',
				label: 'Amount Per Mile',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationUtilityVehicleVan]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationLeadCar]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationPallbearerCar]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationClergyCar]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseAlternativeContainer]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseShippingContainer]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseClothing]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseStationaryCards]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],

		[PbSubcategory.MerchandiseMemorialBook]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseAckCards]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.CashAdvance]: {
		[PbSubcategory.CashAdvanceDeathCertificates]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			{ prop: 'quantity', label: 'Quantity', type: 'text', required: false },
			{
				prop: 'amountPerDeathCertificate',
				label: 'Amount Per Death Certificate',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceObituary]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceFlowers]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'flowersType',
				label: 'Flowers Type',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceHairdresser]: [],
		[PbSubcategory.CashAdvanceClothing]: [],
		[PbSubcategory.CashAdvanceClergyHonorarium]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceMusicianVocalist]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceMusic]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceCremationServices]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Cemetery]: {
		...DefaultCustomItemOptions[PbProductType.Cemetery],
		[PbSubcategory.CemeteryEscorts]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CemeteryInterment]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			...DefaultCustomItemOptions[PbProductType.Cemetery][
				PbSubcategory.CemeteryInterment
			],
		],
	},
	[PbProductType.FamilyTravel]: {
		...DefaultCustomItemOptions[PbProductType.FamilyTravel],
		[PbSubcategory.FamilyTravelGeneral]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
}
